<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          {{ action }}
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="User Account" v-if="!isExternal">
              <b-select
                name="account"
                v-model="editObjectName.account"
                v-on:input="setAccountName"
                :disabled="isAdd"
                expanded
                placeholder="Please select"
              >
                <option selected> </option>
                <option
                  v-for="(option, index) in users"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="First Name">
              <b-input
                name="first_name"
                v-model="editObjectName.first_name"
                required
                :disabled="disableView"
              />
            </b-field>

            <b-field label="Last Name">
              <b-input
                name="last_name"
                v-model="editObjectName.family_name"
                required
                :disabled="disableView"
              />
            </b-field>

            <b-field label="Position">
              <b-input
                name="position"
                v-model="editObjectName.position"
                required
                :disabled="isAdd"
              />
            </b-field>

            <b-field label="Email">
              <b-input
                name="email"
                v-model="editObjectName.email"
                required
                :disabled="disableView"
              />
            </b-field>

            <b-field label="Contact Type">
              <b-select
                expanded
                v-model="editObjectName.contact_type"
                :disabled="isAdd"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in contact_type"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>

            <b-field
              label="Reminder Scope"
              @change="switchOptions"
              v-if="!isExternal"
            >
              <b-select
                required
                expanded
                placeholder="Select reminder scope"
                v-model="editObjectName.reminder_scope"
                @input="switchOptions"
                :disabled="isAdd"
              >
                <option value="all_countries" key="1">
                  Reminder for all countries</option
                >
                <option value="selected_countries" key="2">
                  Reminder for selected countries
                </option>
              </b-select>
            </b-field>

            <b-field
              v-if="
                editObjectName.reminder_scope == 'selected_countries' &&
                  !isExternal
              "
              label="Countries"
            >
              <b-select
                multiple
                placeholder="Select countries"
                v-model="editObjectName.countries"
                expanded
                :disabled="isAdd"
              >
                <option
                  v-for="(option, index) in countries"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>

            <b-field label="Email Types" v-if="!isExternal">
              <b-select
                expanded
                required
                multiple
                placeholder="Select Email Type"
                v-model="editObjectName.email_types"
                :disabled="isAdd"
              >
                <option
                  v-for="(option, index) in ContactEmailTypes"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Send Emails" v-if="!isExternal">
              <b-switch
                name="reminder"
                :checked="true"
                :disabled="isAdd"
                v-model="editObjectName.reminder"
              >
              </b-switch>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot" v-if="!isAdd">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          @click="submit"
        >
          Save
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Cancel
        </b-button>
      </footer>
      <footer class="modal-card-foot" v-if="disable">
        <b-button
          v-if="disable && isAdmin() && this.action !== 'View'"
          slot="right"
          type="is-danger"
          @click="removeContact"
        >
          Delete
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { Permission } from "../../services/Permissions";
import ContactInformationService from "@/services/ContactInformationService";
import UserDataService from "@/services/UserDataService";
import ScopeMixin from "@/mixins/scopeMixin";
import utilityMixin from "@/mixins/UtilityMixin";

// @group Customers
export default {
  name: "ContactInformationAddView",
  mixins: [utilityMixin, ScopeMixin],

  props: {
    action: {
      type: String,
      default: "Inserts"
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    isDelete: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isExternal: {
      type: Boolean,
      default: false
    },
    editObjectName: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    customerId: {
      type: Number,
      default: -1
    }
  },

  data() {
    return {
      isModalActive: false,
      contact_type: [
        "Main Contact",
        "Invoicing",
        "Legal Representative",
        "Regulatory",
        "Reporting Contact",
        "Other"
      ],
      ContactEmailTypes: [
        "All",
        "Reporting Reminders",
        "Reporting Updates",
        "Regulatory Updates",
        "Approval of Reports in Report Manager"
      ],
      streams: [],
      schemes: [],
      users: [],
      userMap: {},
      isUserSelected: false,
      ContactInformationService: new ContactInformationService(),
      userDataService: new UserDataService()
    };
  },
  mounted() {
    this.fetchUserData();
    this.fetchCountries();
  },
  computed: {
    disable() {
      if (this.action == "Edit") {
        return false;
      } else if (this.action == "View") {
        return true;
      } else if (this.action == "Delete") {
        return true;
      }
      return false;
    },
    disableView() {
      // If adding, always disable fields
      if (this.isAdd === true) {
        return true;
      }
      // If editing and a user account is selected, disable fields
      if (
        this.isAdd === false &&
        this.editObjectName.account != null &&
        this.isUserSelected
      ) {
        return true;
      }
      // If no user is selected, enable fields
      return false;
    },

    ...mapGetters(["userId", "userName", "userHasPermission"])
  },
  methods: {
    cancel() {
      // uninitialize user selected flag
      this.isUserSelected = false;
      this.$emit("cancel");
    },
    isAdmin() {
      if (this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL)) {
        return true;
      }
      return true;
    },
    confirm() {
      this.$emit("confirm");
    },
    setAccountName(userId) {
      if (!userId) {
        this.isUserSelected = false;
        this.editObjectName.first_name = "";
        this.editObjectName.family_name = "";
        this.editObjectName.email = "";
        this.isUserSelected == false;
        return;
      }
      const userObject = this.userMap[userId];
      this.editObjectName.first_name = userObject.first_name;
      this.editObjectName.family_name = userObject.last_name;
      this.editObjectName.email = userObject.email;
      this.isUserSelected = true;
    },

    handleApiError(reason) {
      let errorMessage = "";
      for (const v in reason.response.data) {
        errorMessage += v + ": " + reason.response.data[v] + "<br>";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },

    switchOptions() {
      if (this.editObjectName.reminder_scope == "all_countries") {
        this.editObjectName.countries = [];
      }
    },
    convertToArray(obj) {
      if (obj.records instanceof Array) {
        return obj.records;
      } else {
        return [obj.records];
      }
    },
    removeContact() {
      const records = [this.editObjectName];
      this.ContactInformationService.delete(
        records,
        this.$route.params.id
      ).subscribe(response => {
        this.$emit("confirm", response);
        this.$buefy.dialog.alert({
          title: "Success",
          message: "Contact Removed!"
        });
      }, this.handleApiError);
    },
    fetchUserData() {
      const isExternal = true;
      this.userDataService.getAll(isExternal).subscribe(
        response => {
          this.users = response;
          this.userMap = Object.assign(
            {},
            ...this.users.map(x => ({ [x.id]: x }))
          );
          for (const user of this.users) {
            if (user.is_active == false) {
              user.name = user.name + "(Inactive)";
            }
          }
        },
        e => {
          console.log(e);
        }
      );
    },
    submit() {
      let response_data = null;
      //console.log("obj", this.editObjectName);
      if (this.action == "Add") {
        this.ContactInformationService.create(
          this.editObjectName,
          this.customerId
        ).subscribe(response => {
          response_data = response;
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Contact Information Created!"
          });
          this.$emit("confirm", response_data);
        }, this.handleApiError);
      } else if (this.action == "Update") {
        this.editObjectName.email_types = this.editObjectName?.email_types?.toString();
        this.ContactInformationService.update(
          this.editObjectName,
          this.customerId,
          this.editObjectName.id
        ).subscribe(response => {
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Contact Information Updated!"
          });
          this.$emit("confirm", response_data);
        }, this.handleApiError);
      }
    }
  },

  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.editObjectName.email_types = this.editObjectName?.email_types?.toString();
        this.cancel();
      }
    }
  }
};
</script>
